<template>
  <div class="home-header">
    <div class="header-logo">
      <a href="/"></a>
    </div>
    <div class="right-container">
      <template v-if="hasLoginStatus">
        <template v-if="hasLogin">
          <div class="user-menu-container">
            <HeaderUserMenu/>
          </div>
        </template>
        <template v-else>
          <div class="tab-candidate">
            <a class="link" href="/jobseekers/">{{ $t('admin.layout.header.candidate') }}</a>
          </div>
          <div class="tab-employer">
            <a class="link" href="/">{{ $t('admin.layout.header.employer') }}</a>
          </div>
          <div class="tab-intelligence">
            <a class="link" href="/?intelligence=1">{{ $t('admin.layout.header.intelligence') }}</a>
          </div>
          <div class="login-btn">
            <router-link class="link" :to="{ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register`, query: { back: $route.fullPath } }">{{ $t('admin.layout.header.login') }}</router-link>
          </div>
        </template>
      </template>
      <template v-else>

      </template>
      <div class="language-btn" @click="handleLanguageBtnClick">{{ anotherLanguage }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderUserMenu from './headerUserMenu'
import { ACCOUNT_TYPE } from '@/constant/common'

export default {
  components: {
    HeaderUserMenu
  },
  props: {
    hasLoginStatus: {
      default: true
    }
  },
  data () {
    return {
      ACCOUNT_TYPE
    }
  },
  computed: {
    ...mapState('account', ['currentAccount']),
    hasLogin () {
      return this.currentAccount && this.currentAccount.id
    },
    anotherLanguage () {
      if (this.$i18n.locale === 'en') {
        return '简体中文'
      } else {
        return 'English'
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    handleLanguageBtnClick () {
      let languageParam = 'en'
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
        languageParam = 'zh-cn'
      } else {
        this.$i18n.locale = 'en'
      }
      this.changeLanguage(languageParam)
      this.reloadPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  height: 80px;
  font-size: 18px;

  .header-logo {
    width: 165px;
    height: 100%;
    margin: auto 0 auto 4%;
    position: relative;
    background-image: url(~@/assets/image/ajinga_logo_black.png);
    background-size: 165px;
    background-repeat: no-repeat;
    background-position: 0;

    a {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .right-container {
    display: flex;
    margin-left: auto;
    margin-right: 0;

    .ajinga-app {
      margin: auto 0;
      margin-right: 80px;

      &::before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 22px;
        background-image: url($baseDomain + 'static/image/new_homepage/ICON_PHONE_B.PNG');
        background-repeat: no-repeat;
        background-position: 4px 0px;
        vertical-align: middle;
      }

      a {
        margin-left: 5px;
        vertical-align: middle;
        color: #575757;
      }
    }

    .user-menu-container {
      margin: auto 0;
      margin-right: 80px;

      ::v-deep {
        .user-menu {
          top: 0;

          .dropdown-label {
            display: inline-block;
            width: 160px;
            height: auto;
            padding: 0;
            line-height: 30px;
            background: none;

            span {
              vertical-align: middle;
              color: #575757;
              font-weight: normal;
            }

          }
          &::after {
            content: '';
            vertical-align: middle;
            display: inline-block;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 12px solid #000;

          }

          .dropdown-list {
            background: #fff;
            border: solid 1px #575757;
            font-size: 14px;
            top: 35px;

            .dropdown-item {
              border-top: solid 1px #575757;

              &:first-child {
                border-top: 0;
              }

              &:hover {
                background-color: #00AAFF;
              }
            }
          }
        }
      }
    }

    .tab-candidate {
      margin: auto 0;
      margin-right: 80px;

      a {
        color: #575757;
      }
    }

    .tab-employer {
      margin: auto 0;
      margin-right: 80px;

      a {
        color: #575757;
        padding-bottom: 10px;
        border-bottom: 1px solid #575757;
      }
    }

    .tab-intelligence {
      margin: auto 0;
      margin-right: 80px;

      a {
        color: #575757;
      }
    }

    .login-btn {
      width: 100px;
      height: 40px;
      line-height: 40px;
      margin: auto 0;
      margin-right: 80px;
      text-align: center;
      border: 1px solid #575757;

      a {
        color: #575757;
      }
    }

    .language-btn {
      margin: auto 0;
      margin-right: 80px;
      cursor: pointer;
    }
  }
}
</style>
